
export default [
    {
        path: '/home',
        component: () => import('@/pages/home'),
        meta: {
            isActive: true,
            title: '查询'
        }
    },
    {
        path: '/addrcheck',
        component: () => import('@/pages/home/components/addrcheck'),
        meta: {
            isActive: true,
            title: '地址校验'
        }
    },
    {
        path: '/pianyuan',
        component: () => import('@/pages/home/components/pianyuan'),
        meta: {
            isActive: true,
            title: '偏远查询'
        }
    },
    {
        path: '/rate1',
        component: () => import('@/pages/home/components/rate1'),
        meta: {
            isActive: true,
            title: '税率查询'
        }
    },
    {
        path: '/rate2',
        component: () => import('@/pages/home/components/rate2'),
        meta: {
            isActive: true,
            title: '关税查询'
        }
    },
    {
        path: '/fba',
        component: () => import('@/pages/home/components/hwc'),
        meta: {
            isActive: true,
            title: 'fba地址查询'
        }
    },

    {
        path: '/',
        redirect: '/home'
    }
]